import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Divider, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'

import EmbedSetupDrawer from '../EmbedSetupDrawer/EmbedSetupDrawer'
import useEditorModal from '../hooks/useEditorModal/useEditorModal'
import useEmbedSetupDrawer from '../hooks/useEmbedSetupDrawer/useEmbedSetupDrawer'
import TrackingPageEditorModal from '../TrackingPageEditorModal/TrackingPageEditorModal'
import * as Styles from './styles'

const LayoutTab = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { showEditorModal, handleOpenEditorModal, handleCloseEditorModal } = useEditorModal()
  const { showEmbedSetupDrawer, handleOpenEmbedSetupDrawer, handleCloseEmbedSetupDrawer } = useEmbedSetupDrawer()
  const { returnPortalFeatures } = useReturnPortalFeatures({ returnPortalId: info?.selectedReturnPortal?.id })

  return (
    <Styles.Container>
      <Styles.Section>
        <Styles.Content>
          <Text tag="h2" type="titleM">
            {t('Convierte tu página de seguimiento en un momento de marca')}
          </Text>
          <Text type="bodyMRegular">
            {t(
              'Tus clientes consultan el estado de su pedido varias veces tras la compra. Personaliza el layout, añade tu marca y convierte una página funcional en una experiencia de marca fluida.'
            )}
          </Text>
        </Styles.Content>
        <Button onClick={handleOpenEditorModal}>{t('Editar layout')}</Button>
      </Styles.Section>
      <Divider />
      <Styles.Section>
        <Styles.Content>
          <Text tag="h2" type="titleM">
            {t('Lleva tu página de seguimiento a tu propia web')}
          </Text>
          <Text type="bodyMRegular">
            {t(
              'Incrusta la página de seguimiento del pedido directamente en tu web, para que tus clientes nunca tengan que salir de tu dominio para consultar su pedido.'
            )}
          </Text>
        </Styles.Content>
        <Button variant="outlined" onClick={handleOpenEmbedSetupDrawer}>
          {t('Configurar instalación')}
        </Button>
      </Styles.Section>
      {showEditorModal && (
        <TrackingPageEditorModal
          onClose={handleCloseEditorModal}
          storeId={info?.selectedStore?.id}
          timeZone={info?.selectedStore?.timezone}
          smartTrackingEnabled={returnPortalFeatures?.smart_tracking_enabled}
        />
      )}
      <EmbedSetupDrawer
        show={showEmbedSetupDrawer}
        onClose={handleCloseEmbedSetupDrawer}
        storeId={info?.selectedStore?.id}
        storeProvider={info?.selectedStore?.provider}
      />
    </Styles.Container>
  )
}

export default LayoutTab
